import { type PropsWithChildren } from 'react';
import clsx from 'clsx';

type BadgeVariant = 'primary' | 'secondary' | 'neutral' | 'info' | 'warning';
type BadgeSize = 'small' | 'medium' | 'large';

type BadgeProps = PropsWithChildren<{
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
  showDot?: boolean;
}>;

const variantStyles: Record<BadgeVariant, string> = {
  primary: 'bg-green-100 text-green-700',
  secondary: 'bg-green-600 text-white',
  info: 'bg-black text-white',
  warning: 'bg-amber-100 text-amber-700',
  neutral: 'bg-white text-gray-800 border border-green-600',
};

const sizeStyles: Record<BadgeSize, string> = {
  small: 'px-2 py-[2px] text-sm',
  medium: 'px-4 py-2 text-base',
  large: 'px-4 py-4 text-base',
};

// variant: 'info' | 'success' | 'warning' | 'error' | 'neutral';
export default function Badge({
  variant = 'primary',
  size = 'medium',
  className = '',
  showDot = false,
  children,
}: BadgeProps) {
  const baseStyles = 'flex items-center gap-2 rounded-full text-base font-semibold';
  const paddingStyles = sizeStyles[size];

  return (
    <div
      className={clsx([
        baseStyles,
        paddingStyles,
        variantStyles[variant],
        className,
      ])}>
      {showDot && variant === 'primary' && (
        <div className="w-2 h-2 bg-green-600 rounded-full" />
      )}
      <span>{children}</span>
    </div>
  );
}
